import { CheckOutlined, CloseOutlined } from "@qivia/ui";
import { colors } from "@qivia/ui/src/styles/figmaColors";
import { ManagerCreationRole } from "./usersAPI";

type RoleItem = {
  icon: JSX.Element;
  index: string;
};

export const statusColor = {
  ACTIVE: {
    backgroundColor: colors["colors/system/success/success_ultraLight"],
    textColor: colors["colors/system/success/success_normal"],
  },
  PENDING: {
    backgroundColor: colors["colors/system/informative/informative_ultraLight"],
    textColor: colors["colors/system/informative/informative_normal"],
  },
  DEACTIVATED: {
    backgroundColor: colors["colors/surfaces/background/background_level2"],
    textColor: colors["colors/text/black"],
  },
  EXPIRED: {
    backgroundColor: colors["colors/surfaces/background/background_level2"],
    textColor: colors["colors/text/black"],
  },
  CANCELED: {
    backgroundColor: colors["colors/system/error/error_ultraLight"],
    textColor: colors["colors/system/error/error_normal"],
  },
};

const generateRoleDetails = (role: ManagerCreationRole, items: RoleItem[]) =>
  items.map(({ icon, index }) => ({
    icon,
    text: `users.modal.role.informations.${role}.${index}`,
  }));

export const roleDetails: Record<
  ManagerCreationRole,
  { icon: JSX.Element; text: string }[]
> = {
  ADMIN: generateRoleDetails("ADMIN", [
    { icon: <CheckOutlined />, index: "one" },
    { icon: <CheckOutlined />, index: "two" },
    { icon: <CloseOutlined />, index: "three" },
  ]),
  USER: generateRoleDetails("USER", [
    { icon: <CheckOutlined />, index: "one" },
    { icon: <CloseOutlined />, index: "two" },
    { icon: <CloseOutlined />, index: "three" },
    { icon: <CloseOutlined />, index: "four" },
  ]),
  DEPARTMENT_USER: generateRoleDetails("DEPARTMENT_USER", [
    { icon: <CheckOutlined />, index: "one" },
    { icon: <CloseOutlined />, index: "two" },
    { icon: <CloseOutlined />, index: "three" },
    { icon: <CloseOutlined />, index: "four" },
  ]),
};
